import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { PhraseListPlayControls } from '../components/PhraseListPlayControls';
import { IPhraseListPlayControlsEvents, IPhraseListPlayControlsFields } from '../components/types';
import { PhraseListPlayControlsEvents } from './events';
import { PhraseListSelectors } from '../../../../store/phrase-list/selectors';
import { IPhraseListPlayControlsHOCProps } from './types';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState
	): IPhraseListPlayControlsFields => {
		const status = PhraseListSelectors.getPlayMode(state);

		return {
			status,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any,
	{ saveType }: IPhraseListPlayControlsHOCProps,
): IPhraseListPlayControlsEvents => ({
	onPlay: () => dispatch(PhraseListPlayControlsEvents.onPlay(saveType)),
	onStop: () => dispatch(PhraseListPlayControlsEvents.onStop()),
	onPrev: () => dispatch(PhraseListPlayControlsEvents.onPrev(saveType)),
	onNext: () => dispatch(PhraseListPlayControlsEvents.onNext(saveType)),
});

export const PhraseListPlayControlsHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(PhraseListPlayControls) as any;

PhraseListPlayControlsHOC.displayName = 'PhraseListPlayControlsHOC';
